import {_} from 'lodash';
import {IAuthenticationType, ICompany, ICompanySyncstep, IdName} from "../../../index";
import {DEFAULT_SMTP_SENDER} from "../../../constants";
import {ImportFormatId} from "../../../constants/ImportFormats";

export namespace nsCustomerGeneral {
    export const DefaultValues: ICompany = {
        addmanagedbytoautogroupsmanagers: false,
        agressoorguntitype: '',
        authenticationtype: {id: 5} as IAuthenticationType,
        authenticationtypes: 0,
        autodistributiongroupnamingexpression: '',
        autoextendlifeaccounts: 0,
        autosecuritygroupnamingexpression: '',
        changepasswordrequiresoldpassword: true,
        cloudschedule: false,
        comment: '',
        daystosyncstopwarning: 0,
        defaultexpirypermissions: 365,
        defaultsmtpsender: DEFAULT_SMTP_SENDER,
        deltasync: false,
        directmembernestedgroupsnamingexpression: '',
        eadmapipassword: '',
        eadmapiusername: '',
        eformforeadm: false,
        enableapiusersforcompanyadmins: false,
        encryptedeadmapipassword: 'test',
        encryptedeadmapiusername: 'test',
        forcefullsync: false,
        forgotpassordbankidse: false,
        forgotpassordidporten: true,
        forgotpassordsms: true,
        forgotpassordteliafi: false,
        generatedepartmentdistributiongroups: false,
        generatedepartmentgroups: false,
        generatedirectmembernestedgroups: false,
        generatefullemployeeorgpath: false,
        getaccountsdaysbefore: 14,
        getdepartmentfromaccountingdimension: false,
        getdepartmentfromorgunit: false,
        grandidapikey: '',
        grandidservicekey: '',
        hidename: false,
        hostedbyidentum: false,
        id: '',
        ignoreimportfilter: false,
        ignoreimportfilteruntil: '',
        importfilterdeactivated: "",
        importfilterdeactivatedby: 0,
        importfilterdeactivatedbyorgnr: "",
        importformathi: {id: ImportFormatId.Visma_Hierachy} as IdName,
        importformathr: {id: ImportFormatId.Visma} as IdName,
        importformathr2: null,
        importformatsas: null,
        importsystemfromhierarchy: false,
        lastsasimportfile: null,
        lastsyncstep: null,
        loglevel: 2,
        managergroupsrulefilter: null,
        managerscanmanagepasswords: true,
        maxdeletes: 10,
        maxedit: 10,
        maxnew: 10,
        memberfilterdistgroups: null,
        memberfilternestgroups: null,
        memberrulefilterautogroups: null,
        mergeattributeprefix: '',
        mobilefield2fa: '',
        name: '',
        nesteddepartmentgroups: false,
        onlyeform: false,
        orgchartfilterrule: null,
        passwordgenerationrule: {id: 7} as IdName,
        pausedeltasync: false,
        populateuseraddressfieldsfromdepartment: false,
        positionfilter: null,
        purgedeactivatedaccountsafterdays: 0,
        purgemanualrolesondelete: false,
        syncendreportrecipients: 'noreply@identum.no',
        syncendreportsdeactivated: '',
        syncendreportsdeactivatedby: 0,
        syncendreportsdeactivatedbyorgnr: '',
        syncerrorreportrecipients: 'noreply@identum.no',
        senddetailedsyncreport: false,
        sendwarningonstop: true,
        smsfield: '',
        smssenders: '',
        softmatchcalculateprimaryposition: false,
        softmatchfieldmanualobject: 0,
        softmatchfieldobject: 0,
        ssogoogleidpid: null,
        ssotenantid: null,
        status: {id: 1} as IdName,
        syncableedits: false,
        syncsteps: null,
        syncstopwarningdeactivated: '',
        syncstopwarningdeactivatedby: 0,
        syncstopwarningdeactivatedbyorgnr: '',
        testcompany: false,
        usernameexpression: '',
        usernamegenerationrule: {id: 12} as IdName,
        usernameprefix: '',
        usernamesharingcompany: '',
        vanitynames: '',
        vismagetmanagerfromrole: '',
        vismaincludecharttopnode: false
    };

    export const logLevel = [
        {
            value: 0,
            label: 'low'
        },
        {
            value: 1,
            label: 'medium'
        },
        {
            value: 2,
            label: 'high'
        },
    ]

    export function urlEncodeCustomerKeys(companySyncsteps: ICompanySyncstep[]): ICompanySyncstep[] {
        return companySyncsteps?.map(o => urlEncodeCustomerKey(o)) ?? []
    }

    export function urlEncodeCustomerKey(companySyncstep: ICompanySyncstep): ICompanySyncstep {
        const ret = _.cloneDeep(companySyncstep)
        ret.customerkey = encodeURIComponent(ret.customerkey ?? '')
        return ret
    }

    // the username generation rule that can be accompanied with an expression
    export const USERNAME_GENERATION_RULE_ID_FOR_EXPRESSION = 28
}